import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire } from '@fortawesome/free-solid-svg-icons';
import { history } from "../_core/history";
import { chunk } from "../_helpers";
// import { Nav } from 'react-bootstrap';
//style
import './MainNav.sass'

class MainNav extends Component {

	menus = (menu) => {
		//check if menu have menu and menu items
		if (menu && menu.items && menu.items.length > 0) {
			//pass menu to function (to sort menu items)
			const menus = this.getMenu(menu);
			return menus
		} else {
			return menu
		}
	}

	hotOffers = (e) => {
		e.preventDefault()
		history.push({
		pathname: '/hot-offers'
		})
		window.location.reload();
	}

	getMenu = (menu) => {
		const menus = menu;
		var newMenu = [];

		// if(!menus.items) return false;

		//loop menu items to sort submenus by section
		var menuList = menus.items && menus.items.map((item) => {
			//if primary menu have submenu/s
			if (item.items && item.items.length > 0) {
				var itemsPerSection;
				var itemstoArray;
				var newItem = [];
				var prevItem = item;

				//regroup submenus by section, returns object
				itemsPerSection = item.items.reduce((result, currentValue) => {
					let section = currentValue.sectionLabel || currentValue.section;
					(result[section] = result[section] || []).push(currentValue);
					return result
				}, {});

				//regrouped by sections, convert object (entries) to array 
				//ex: {Guitars: [{name: "Bass", ...}]} to [["Guitars"], [{name: "Bass", ...}]]
				itemstoArray = Object.entries(itemsPerSection).map((item) => {
					return item
				})

				//add changes to new array
				newItem.push({
					...prevItem,
					items: itemstoArray
				});

				return newItem[0]
			} else {
				return item
			}
		})

		//push sorted menus and submenus to new array then return
		newMenu.push({
			...menus,
			items: menuList
		})

		return newMenu[0]
	}

	render() {
		//pass props to function
		const getMenu = this.props.menu;
		var menus = this.menus(getMenu);


		return (
			<ul className="navbar-nav">
				{menus && menus.items && menus.items.map((menuItem, index) =>
					<li className="nav-item dropdown megamenu" key={index}>
						{menuItem.child_items && menuItem.child_items.length > 0 ? (
							<>
								<a id="megamenu" className="nav-link" aria-haspopup="true" aria-expanded="false" href={menuItem.url}>{menuItem.title}</a>
								<div className="dropdown-menu p-0">
									<div className="container">
										<div className="row">
											<div className="d-flex flex-wrap flex-md-nowrap px-2">
												{index !== menus.items.length - 1 && ( // Check if it's not the last menuItem
													<div className="megamenu-column py-4 px-3">
														<a href={menuItem.url}>
															<img style={{ "width": "100%", "maxWidth": "150px", "height": "auto" }} src={menuItem.description ? menuItem.description : "https://via.placeholder.com/150"} alt="" />
														</a>
													</div>
												)}

												{menuItem.child_items && menuItem.child_items.length > 0 && (
													<>
														{chunk(menuItem.child_items, 2).map((column, columnIndex) => (
															<div className="megamenu-column py-4 px-3" key={columnIndex}>
																{column.map((submenu, subIndex) => (
																	<React.Fragment key={subIndex}>
																		<h5 className="mb-2">
																			<a href={submenu.url}>{submenu.title}</a>
																		</h5>
																		<ul className="list-unstyled sub-level m-0 p-0">
																			{submenu?.child_items?.map((subsubmenu, subsubIndex) => (
																				<li className="pb-1" key={subsubIndex}>
																					<a className="submenu-items" href={subsubmenu.url}>{subsubmenu.title}</a>
																				</li>
																			))}
																		</ul>
																	</React.Fragment>
																))}
															</div>
														))}
													</>
												)}
											</div>
										</div>
									</div>
								</div>
							</>
						) : (
							<a className="nav-link" href={menuItem.url}>{menuItem.title}</a>
						)}
					</li>
				)}

				{/* {menus && menus.items && menus.items.map((menu, index) =>
				<li className="nav-item dropdown megamenu" key={index}>
						{menu.items && menu.items.length > 0 ?
							<>
								<a id="megamenu" className="nav-link" aria-haspopup="true" aria-expanded="false" href={menu.path} >{menu.name}</a>
								<div className="dropdown-menu p-0">
									<div className="container">
										<div className="row">
											<div className="d-flex flex-wrap flex-md-nowrap px-2">
												<div className="megamenu-column py-4 px-3">
													<a href={menu.imageUrl}>
														<img style={{ "width": "100%", "maxWidth": "300px", "height": "auto" }} src={menu.image ? menu.image : menus.image ? menus.image : "https://via.placeholder.com/150"} alt="" />
													</a>
												</div>
												{
												  menu.items &&
												    chunk(
												      menu.items.reduce((acc, obj, index) => {
												        const perCol = 2;
												        const col = Math.floor(menu.items.length / perCol);
												        const pos = (index - col) * perCol + 1;
												        if (pos > 0) {
												          acc.splice(pos, 0, obj);
												        } else {
												          acc.push(obj);
												        }
												        return acc;
												      }, []),
												      2
												    ).map((arr, index) => (
												      <div className="megamenu-column py-4 px-3" key={index}>
												        {arr.map((submenu) => (
												          <React.Fragment key={submenu[0]}>
												            <h5 className="mb-2">
												              <a
												                href={
												                  "/" +
												                  submenu[0]
												                    .replace(/^\s+|\s+$/g, "")
												                    .replace(/ /g, "-")
												                    .replace("&", "and")
												                    .toLowerCase()
												                }
												              >
												                {submenu[0]}
												              </a>
												            </h5>
												            <ul className="list-unstyled sub-level m-0 p-0">
												              {submenu[1].map((submenu) => (
												                <li className="pb-1" key={submenu.name}>
												                  <a className="submenu-items" href={submenu.path}>
												                    {submenu.name}
												                  </a>
												                </li>
												              ))}
												            </ul>
												          </React.Fragment>
												        ))}
												      </div>
												    ))
												}
											</div>
										</div>
									</div>
								</div>
							</>
							:
							<a className="nav-link" href={menu.path}> {menu.name ? menu.name : menus.name} </a>
						}
					</li>
				)} */}
				<li className="nav-item nav-promo"><a href="#!" className="nav-link" onClick={this.hotOffers}><FontAwesomeIcon icon={faFire} /> Hot Offers</a></li>
			</ul>
		)
	}
}

export default MainNav